import { Block, ErrorOutline } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { FlexColumnCenter, FlexRowCenter } from '../../../components/LayoutBoxes';
import { iconStyles } from '../../../styles/iconStyles';
import { authStyles as styles } from '../styles/authStyles';

/**
 * No Access Page - shown when host auth fails and fallback to Cognito is disabled
 */
export const NoAccessPage: React.FC = () => {
  return (
    <FlexColumnCenter sx={styles.noAccessContainer}>
      <Paper elevation={0} sx={styles.noAccessCard}>
        <Box sx={styles.noAccessIconCircleError}>
          <Block sx={iconStyles.circleIconLg} />
        </Box>
        <Typography variant='h5' sx={styles.noAccessTitle}>
          Access Not Available
        </Typography>
        <Typography variant='body1' sx={styles.noAccessBodyText}>
          Authentication is managed by the host application and is currently
          unavailable.
        </Typography>
        <FlexRowCenter sx={styles.noAccessHelpBox}>
          <ErrorOutline sx={iconStyles.secondary} />
          <Typography variant='body2' sx={styles.noAccessHelpText}>
            Contact your administrator for help
          </Typography>
        </FlexRowCenter>
      </Paper>
    </FlexColumnCenter>
  );
};
